import { triggersNamespace } from "../triggers-namespace";

export const appNamespace = `${triggersNamespace}app/`